module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.alert || _vm.refreshAlert) ? _c('div', {
    attrs: {
      "id": "notice"
    }
  }, [_c('ul', [_vm._v("\n    STAGING\n\n  ")])]) : _vm._e(), _vm._v(" "), _c('loading-page'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5adf186"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1747
// module chunks = 2